// extracted by mini-css-extract-plugin
export default {"root":"ChatMessageReactionList_root__g76p1"};